import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { valueConcepts } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ValueSection() {
  return <section className="bg-mp-black py-16 md:py-24" data-id="element-351" data-mp="iew1x3idd5sf">
      <Container data-id="element-352" data-mp="igfikv7xtiuq">
        <div className="mx-auto max-w-[750px] text-center" data-id="element-353" data-mp="df9mqoizdfgz">
          <SectionTag tone="lime" data-id="element-354" data-mp="dgugwd1duweb">Más que ejercicios</SectionTag>
          <h2 className="mt-5 font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl md:text-4xl" data-id="element-355" data-mp="8o9rdnpif5gl">
            No se trata de tener más ejercicios. Se trata de aumentar el valor de tu trabajo.
          </h2>

          <div className="mx-auto mt-6 max-w-[650px] space-y-3 text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-356" data-mp="3ux2jvukezt0g">
            <p data-id="element-357" data-mp="3qtcytf2y7tk6">
              Cuando tus clases tienen estructura, progresión y una metodología reconocible, tu trabajo transmite
              mayor profesionalidad.
            </p>
            <p data-id="element-358" data-mp="1j91pn7ca1g6z">
              Maestro en Pista está diseñado para ayudarte a organizar mejor tus clases, aportar más valor al
              alumno y construir un servicio que no dependa de improvisar cada semana.
            </p>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto mt-10 grid max-w-[700px] grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-359" data-mp="1eagvnpnmbsqz">
          {valueConcepts.map(concept => <div key={concept} className="rounded-xl border border-mp-border bg-mp-card px-5 py-4 text-center font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-360" data-mp="1szczfain6jls">
              {concept}
            </div>)}
        </motion.div>
      </Container>
    </section>;
}